import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Input, Checkbox, Breadcrumb } from 'antd';
import { Tabs, Modal, ListView, List } from 'antd-mobile';
import { withCookies, Cookies } from 'react-cookie';
import styles from './selectmember.module.css'
import { _getMember, _getDepartmen, _searchMember, _listTag } from "../../server";
import "../../assets/fonts/iconfont.css"

const Item = List.Item;
const Brief = Item.Brief;

const alert = Modal.alert;

const tabs = [
    { title: '成员' },
    { title: '标签' },
];
const letterData = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "M", "L", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "*"];

let pageIndex = 0;
let pageSize = 30;

function closest(el, selector) {
    const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    while (el) {
        if (matchesSelector.call(el, selector)) {
            return el;
        }
        el = el.parentElement;
    }
    return null;
}

class SelectMember extends React.Component {

    maxLength = 30;

    constructor(props) {
        super(props)
        this.sid = this.props.sid;

        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 != row2
        });

        this.state = {
            dataSource,
            isLoading: true,
            height: document.documentElement.clientHeight * 3 / 4 + 13,
            letterListVisible: false,
            organization: {
                departments: [],
                members: [],
                parents: [],
            },
            members: [],
            selectedMembers: [],
            showSelected: false,
            checkWay: '2',
            searchKey: '',
            modalVisible: false,
            status: 1,
            tagList: [],
        };
    }

    componentDidMount() {
        this.refresh(null);
        this.props.triggerRef(this);
    }

    componentWillUnmount() {

    }

    refresh = (sid) => {
        if (sid) {
            this.sid = sid;
        }
        if (this.sid) {
            this.getMember(1);
            this.refreshDepartments(1);
            this.listTag();
        }
    }

    async listTag() {
        const res = await _listTag(this.sid);
        if (res.code === 0) {
            this.setState({ tagList: res.data.list });
        }
    }

    async getMember(departmentId) {
        const res = await _getMember(this.sid, departmentId, this.state.status, pageIndex, pageSize);
        if (res.code === 0) {
            this.state.members = this.state.members.concat(res.data.list);
            this.state.members.map((item, index) => {
                item.checked = false;
                for (var i = 0; i < this.state.selectedMembers.length; i++) {
                    if (this.state.selectedMembers[i].userid == item.userid) {
                        item.checked = true;
                        break;
                    }
                }
            })
            this.setState({
                members: this.state.members,
                dataSource: this.state.dataSource.cloneWithRows(this.state.members),
                isLoading: false
            });
        }
    }

    async searchMember(val) {
        const res = await _searchMember(this.sid, val, this.state.status);
        if (res.code === 0) {
            this.state.members = [].concat(res.data.list);
            this.state.members.map((item, index) => {
                item.checked = false;
                for (var i = 0; i < this.state.selectedMembers.length; i++) {
                    if (this.state.selectedMembers[i].userid == item.userid) {
                        item.checked = true;
                        break;
                    }
                }
            })
            this.setState({
                checkWay: '2',
                members: this.state.members,
                dataSource: this.state.dataSource.cloneWithRows(this.state.members),
                isLoading: false
            });
        }
    }

    async refreshDepartments(departmentId) {
        let memberList = [];
        if (departmentId !== 1) {
            const res = await _getMember(this.sid, departmentId, this.state.status);
            if (res.code === 0) {
                res.data.list.map((item, index) => {
                    item.checked = false;
                    for (var i = 0; i < this.state.selectedMembers.length; i++) {
                        if (this.state.selectedMembers[i].userid == item.userid) {
                            item.checked = true;
                            break;
                        }
                    }
                })
                memberList = [].concat(res.data.list);
            }
        }

        let parentList = [];
        let departments = [];
        const res2 = await _getDepartmen(this.sid, departmentId);
        if (res2.code === 0) {
            departments = res2.data.list;
            if (departmentId !== 1) {
                parentList = res2.data.parentList;
            }
        }
        let data = Object.assign({}, this.state.organization, { departments: departments, members: memberList, parents: parentList })
        this.setState({ organization: data });
    }

    removemember = (index) => {
        let removeindex = index.index
        let members = this.state.selectedMembers
        let removeItem = members[removeindex]
        members.splice(removeindex, 1)

        this.onSelectUser(false, removeItem.userid);

        this.state.tagList.map((item, index) => {
            if (item.checked) {
                for (var i = 0; i < item.membersList.length; i++) {
                    var has = false;
                    for (var j = 0; j < members.length; j++) {
                        if (item.membersList[i].userid === members[j].userid) {
                            has = true;
                            break;
                        }
                    }
                    if (!has) {
                        item.checked = false;
                        break;
                    }
                }
            }
        });
        this.setState({ tagList: this.state.tagList });
    }

    changeCheckWay = (way) => {
        this.setState({ checkWay: way })
    }

    search = (val) => {
        this.state.searchKey = val;
        this.state.members = [];
        this.setState({
            checkWay: '2',
            members: this.state.members,
            dataSource: this.state.dataSource.cloneWithRows(this.state.members),
            isLoading: false
        });
        if (!this.state.searchKey) {
            this.getMember(1);
        } else {
            this.searchMember(this.state.searchKey);
        }
    }

    searchLetter = (e) => {
        this.searchMember(e.target.innerText);
        this.setState({ letterListVisible: !this.state.letterListVisible });
    }

    checkOrganization = (value) => {
        this.refreshDepartments(value);
    }

    onSelectTag(e, tag) {
        let resetItem = '';
        if (tag.membersList) {
            for (var i = 0; i < tag.membersList.length; i++) {
                resetItem = this.updateSelectedData(tag.membersList[i], e.target.checked);
                if (resetItem) {
                    alert('提示', '最多选择' + this.maxLength + '个成员。',
                        [{
                            text: '确定'
                        },]);
                    break;
                }
            }
            tag.checked = e.target.checked;
            if (resetItem) {
                tag.checked = false;
            }
        }
    }

    onSelectUser(isChecked, userid) {
        let resetItem = '';
        let isOutOfLimit = false;
        var members = [].concat(this.state.members);
        members.map((item, index) => {
            if (item.userid == userid) {
                item.checked = isChecked;
                resetItem = this.updateSelectedData(item, isChecked);
                if (resetItem) {
                    isOutOfLimit = true;
                }
            }
            if (resetItem && item.userid == resetItem) {
                item.checked = false;
                resetItem = '';
            }
        })
        if (resetItem) {
            members.map((item, index) => {
                if (item.userid == resetItem) {
                    item.checked = false;
                    resetItem = '';
                }
            })
        }

        this.state.organization.members.map((item, index) => {
            if (item.userid == userid) {
                item.checked = isChecked;
                resetItem = this.updateSelectedData(item, isChecked);
                if (resetItem) {
                    isOutOfLimit = true;
                }
            }
            if (resetItem && item.userid == resetItem) {
                item.checked = false;
                resetItem = '';
            }
        })
        if (resetItem) {
            this.state.organization.members.map((item, index) => {
                if (item.userid == resetItem) {
                    item.checked = false;
                    resetItem = '';
                }
            })
        }
        if (isOutOfLimit) {
            alert('提示', '最多选择' + this.maxLength + '个成员。',
                [{
                    text: '确定',
                    onPress: () => {
                        this.setState({
                            members,
                            organization: this.state.organization,
                            dataSource: this.state.dataSource.cloneWithRows(members)
                        });
                    }
                },]);
        } else {
            this.setState({
                members,
                organization: this.state.organization,
                dataSource: this.state.dataSource.cloneWithRows(members)
            });
        }
    }

    updateSelectedData(data, op) {
        let resetItem = '';
        let index = -1;
        for (var i = 0; i < this.state.selectedMembers.length; i++) {
            if (this.state.selectedMembers[i].userid == data.userid) {
                index = i;
                break;
            }
        }
        if (op) {
            if (index == -1) {
                if (this.state.selectedMembers.length >= this.maxLength && this.maxLength > 0) {
                    //超过最大限制
                    resetItem = this.state.selectedMembers[0].userid;
                    this.state.selectedMembers.splice(0, 1);
                }
                this.state.selectedMembers.splice(this.state.selectedMembers.length, 0, data);
            }
        } else {
            if (index != -1) {
                this.state.selectedMembers.splice(index, 1);
            }
        }
        this.setState({ selectedMembers: this.state.selectedMembers });

        return resetItem;
    }

    showModal = () => {
        this.setState({ selectedMembers: [], });
        if (!this.state.members) {
            this.state.members = [];
        }

        try {
            if (this.props.extra && this.props.extra.commonList) {
                if (this.props.extra.commonList.length > 0) {
                    // var commonList = [];
                    // for (var j = 0; j < this.props.extra.commonList.length; j++) {
                    //     var isHas = false;
                    //     for (var i = 0; i < this.state.members.length; i++) {
                    //         if (this.state.members[i].userid === this.props.extra.commonList[j].userid) {
                    //             isHas = true;
                    //             break;
                    //         }
                    //     }
                    //     if (!isHas) {
                    //         commonList.push(this.props.extra.commonList[j]);
                    //     }
                    // }
                    // this.state.members = commonList.concat(this.state.members);
                    this.state.members = [].concat(this.props.extra.commonList);
                }
            }
        } catch (err) {

        }

        if (this.props.selectedData) {
            var selectedList = [...this.props.selectedData];
            this.setState({ selectedMembers: selectedList, });

            this.state.members.map((item, index) => {
                item.checked = false;
                for (var i = 0; i < selectedList.length; i++) {
                    if (selectedList[i].userid == item.userid) {
                        item.checked = true;
                        break;
                    }
                }
            })

            if (this.state.organization && this.state.organization.members) {
                var organization = this.state.organization;
                if (organization.members) {
                    organization.members.map((item, index) => {
                        item.checked = false;
                        for (var i = 0; i < selectedList.length; i++) {
                            if (selectedList[i].userid == item.userid) {
                                item.checked = true;
                                break;
                            }
                        }
                    })
                }
                this.setState({ organization: organization, });
            }
        }
        this.setState({ members: this.state.members, dataSource: this.state.dataSource.cloneWithRows(this.state.members), });
        this.setState({ modalVisible: true, });
        if (this.props.extra && this.props.extra.maxLength && this.props.extra.maxLength > 0) {
            this.maxLength = this.props.extra.maxLength;
        } else {
            this.maxLength = 30;
        }
    }

    goBack() {
        this.setState({ modalVisible: false, });
    }

    handleOk = e => {
        var selectedData = [].concat(this.state.selectedMembers);
        this.props.callback(this.props.extra, selectedData);
        this.setState({ modalVisible: false, });
    };

    onEndReached = (event) => {
        if (this.state.searchKey) {
            return;
        }
        if (this.state.isLoading && !this.state.hasMore) {
            return;
        }
        this.setState({ isLoading: true });
        ++pageIndex;
        this.getMember(1);
    }

    renderRow = (rowData, rowID) => {
        return <li key={rowID} style={{ paddingLeft: 20, paddingTop: 10, display: 'block' }}>
            <Checkbox style={{ width: '100%' }} disabled={rowData.disabled}
                defaultChecked={rowData.checked}
                onChange={(e) => this.onSelectUser(e.target.checked, rowData.userid)}>
                <img src={rowData.avatar}></img><span>{rowData.name}</span>
            </Checkbox>
        </li>
    }

    onWrapTouchStart = (e) => {
        // fix touch to scroll background page on iOS
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        const pNode = closest(e.target, '.am-modal-content');
        if (!pNode) {
            e.preventDefault();
        }
    }

    render() {
        return (
            <Modal wrapProps={{ onTouchStart: this.onWrapTouchStart }} visible={this.state.modalVisible} animationType="slide-up">
                <div className={styles.userOrDept_select}>
                    <div className={styles.searchbox}>
                        <LeftOutlined onClick={() => this.goBack()} className={styles.back} />
                        <Input.Search allowClear defaultValue={this.state.searchKey} onSearch={this.search} className={styles.input} placeholder="姓名/拼音" />
                        <div className={styles.more} onClick={() => this.setState({ letterListVisible: !this.state.letterListVisible })}>
                            <div className={styles.search_letter_btn}><i className={styles.ic_letterList}></i></div>
                            {
                                this.state.letterListVisible ?
                                    <div className={styles.letter_list}>
                                        <ul>
                                            {letterData.map((item, index) => <li key={index} onClick={this.searchLetter}><a>{item}</a></li>)}
                                        </ul>
                                    </div> : ""
                            }
                        </div>
                    </div>
                    <div className={styles.tabs}>
                        <Tabs tabBarActiveTextColor='#FF884D' tabBarUnderlineStyle={{ border: '1px #FF884D solid' }} tabs={tabs} initialPage={0} animated={false} useOnPan={false}>
                            <div style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
                                {
                                    this.state.checkWay == "1" ?
                                        <div onClick={this.changeCheckWay.bind(this, '2')} className={styles.checkmode}>按成员姓名查看<RightOutlined className={styles.righticon} /></div>
                                        : <div onClick={this.changeCheckWay.bind(this, '1')} className={styles.checkmode}>按组织架构查看<RightOutlined className={styles.righticon} /></div>
                                }
                                {
                                    this.state.checkWay == "2" ?
                                        <ListView
                                            contentContainerStyle={{ paddingTop: 50 }}
                                            ref={el => this.lv = el}
                                            dataSource={this.state.dataSource}
                                            renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>{this.state.isLoading ? '加载中...' : '共' + this.state.members.length + '个成员'}</div>)}
                                            renderRow={(rowData, rowID) => this.renderRow(rowData, rowID)}
                                            style={{ height: this.state.height, overflow: 'auto' }}
                                            pageSize={pageSize}
                                            removeClippedSubviews={false}
                                            onEndReached={this.onEndReached}
                                            onEndReachedThreshold={1000}
                                        />
                                        :
                                        <span>
                                            <Breadcrumb className={styles.myBreadcrumb} separator="/" style={{ padding: "55px 5px 8px 5px", textAlign: "left" }}>
                                                <Breadcrumb.Item onClick={this.checkOrganization.bind(this, 1)}>全部</Breadcrumb.Item>
                                                {
                                                    this.state.organization.parents.length > 0 ? this.state.organization.parents.map((item, index) => <Breadcrumb.Item key={index} onClick={this.checkOrganization.bind(this, item.id)}>{item.name}</Breadcrumb.Item>) : ""
                                                }
                                            </Breadcrumb>
                                            <List style={{ height: this.state.height, overflow: 'auto', padding: '0 0 60px 0' }}>
                                                {
                                                    this.state.organization.members.map((item, index) => {
                                                        return <li key={index} style={{ paddingLeft: 20, display: 'block' }}>
                                                            <Checkbox style={{ width: '100%' }} defaultChecked={item.checked} checked={item.checked} onChange={(e) => this.onSelectUser(e.target.checked, item.userid)}><img src={item.avatar}></img><span>{item.name}</span></Checkbox>
                                                        </li>
                                                    })
                                                }
                                                {
                                                    this.state.organization.departments.map((item, index) => {
                                                        return <Item key={index}
                                                            arrow="horizontal" multipleLine
                                                            thumb={<img style={{ height: 30, width: 30 }} src={require("../../assets/img/department.png")}></img>}
                                                            onClick={this.checkOrganization.bind(this, item.id)}>{item.name}
                                                        </Item>
                                                    })
                                                }
                                            </List>
                                        </span>
                                }
                            </div>
                            <div style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#fff' }}>
                                {
                                    this.state.tagList.length > 0 ? <ul>
                                        <li style={{ paddingLeft: 20, display: 'block' }}>按标签选人</li>
                                        {
                                            this.state.tagList.map((item, index) => {
                                                return <li key={index} style={{ paddingLeft: 20, display: 'block', paddingTop: 10 }}>
                                                    <Checkbox style={{ width: '100%' }}
                                                        defaultChecked={item.checked} checked={item.checked} onChange={(e) => this.onSelectTag(e, item)}>
                                                        <img className={styles.iconTag} src={require('../../assets/img/tag.png')} />
                                                        <span>{item.name}</span>
                                                    </Checkbox>
                                                </li>
                                            })
                                        }
                                    </ul> : <div className={styles.empty}><div className={styles.img}></div><p className={styles.desc}>暂无数据</p></div>
                                }
                            </div>
                        </Tabs>
                    </div>
                    <div className={styles.submitline}>已选择:
                            {
                            this.state.selectedMembers.length == 1 ?
                                <span onClick={() => this.setState({ showSelected: !this.state.showSelected })} className={styles.selectednumber}>{this.state.selectedMembers[0].name}</span>
                                : <span onClick={() => this.setState({ showSelected: !this.state.showSelected })} className={styles.selectednumber}>{this.state.selectedMembers.length + '成员'}</span>
                        }
                        <div className={styles.submitbtn} onClick={() => this.handleOk()}>确定</div>
                    </div>
                    {
                        this.state.showSelected ?
                            <div className={styles.selected}>
                                <p style={{ textAlign: 'left', marginLeft: '10px', marginTop: '10px' }}>已选择 {this.state.selectedMembers.length} 成员</p>
                                <ul>
                                    {
                                        this.state.selectedMembers.map((item, index) => {
                                            return <li key={index}><img src={item.avatar}></img><a className={styles.icon_remove} onClick={this.removemember.bind(this, { index })}></a><p>{item.name}</p></li>
                                        })
                                    }
                                </ul>
                                <div className={styles.btnline}>
                                    <div className={styles.btn} onClick={() => this.setState({ showSelected: !this.state.showSelected })}>确定</div>
                                </div>
                            </div> : null
                    }
                </div>
            </Modal>
        );
    }
}

export default SelectMember;